import { render, staticRenderFns } from "./HolidayConfig.vue?vue&type=template&id=e1ee81ee&scoped=true"
import script from "./HolidayConfig.vue?vue&type=script&lang=js"
export * from "./HolidayConfig.vue?vue&type=script&lang=js"
import style0 from "./HolidayConfig.vue?vue&type=style&index=0&id=e1ee81ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ee81ee",
  null
  
)

export default component.exports